import _ from 'lodash';
import { useEffect, useRef, useState } from 'react'
import * as Linking from 'expo-linking';
import HelperValidate from 'utils/helper-validate'
import store from 'services/redux/store'
import { dataConstants } from 'services/redux/data/constants'
import { createUrl } from 'utils/helper-url'
import { setData } from 'services/redux/data/actions'
import { MODES } from 'utils/constants/app-modes'

export const isManagementDomain = () => {
	const url = store.getState().data[ dataConstants.INITIAL_URL ]

	switch( true ) {
		case _.startsWith( url, 'https://admin.myofficedays.com/' ):
		case _.startsWith( url, 'https://test-admin.myofficedays.com/' ):
		case _.startsWith( url, 'https://management.myofficedays.com/' ):
		case _.startsWith( url, 'https://test-management.myofficedays.com/' ):
			return true;
		
		default:
			return false;
	}
}

const useIsIn = ( validate ) => {
	
	const urlRef = useRef()
	const [ result, setResult ] = useState(undefined );
	
	const onChange = ({ url }) => {
		if( typeof url !== 'undefined' && url !== urlRef.current ) {
			urlRef.current = url;
			
			onValidate()
		}
	}
	
	const onValidate = () => {
		if( HelperValidate.isValid( urlRef.current ) ) {
			validate( urlRef.current, value => {
				if( result !== value ) {
					setResult( value )
				}
			} )
		}
	}
	
	useEffect(() => {
		Linking.getInitialURL().then( url => {
			return onChange({
				url
			});
		} );
		
		const listener = Linking.addEventListener('url', onChange );
		
		return listener.remove
	}, [] );
	
	return result
}

export const useIsInManagement = () => {
	
	return useIsIn( ( url, setResult ) => {
		let isIn;
		
		switch( true ) {
			case _.startsWith( url, 'https://admin.myofficedays.com/' ):
			case _.startsWith( url, 'https://test-admin.myofficedays.com/' ):
			case _.startsWith( url, 'https://management.myofficedays.com/' ):
			case _.startsWith( url, 'https://test-management.myofficedays.com/' ):
			case _.startsWith( url, createUrl(`admin` ) ):
			case _.startsWith( url, createUrl(`management` ) ):
				isIn = true;
				break;
			
			default:
				isIn = false
		}
		
		setResult( isIn )
		store.dispatch( setData( dataConstants.MODE, isIn ? MODES.MANAGEMENT : MODES.APP ) );
	});
}

export const useIsInEmailResponse = () => {
	
	return useIsIn( ( url, setResult ) => {
		let isIn;
		
		switch( true ) {
			case _.startsWith( url, 'https://app.myofficedays.com/response/' ):
			case _.startsWith( url, 'https://test-app.myofficedays.com/response/' ):
			case _.startsWith( url, createUrl(`response/` ) ):
				isIn = true;
				break;
			
			default:
				isIn = false
		}
		
		setResult( isIn )
	});
}
